
import {
  InjectionSiteDto,
  CreateInjectionSiteDto,
  UpdateInjectionSiteDto,
} from './dtos'
import { BaseCrudService } from './BaseCrudService'
import { PaginatedQueryBase } from './api'

export type InjectionSitesFilters = PaginatedQueryBase & {
  includeInactive?: boolean
}

class InjectionSiteService extends BaseCrudService<
  InjectionSiteDto,
  CreateInjectionSiteDto,
  UpdateInjectionSiteDto,
  InjectionSitesFilters
> {
  constructor() {
    super('injection-site', process.env.REACT_APP_RADIOPHARMACY_API_URL)
  }
}

export const injectionSiteService = new InjectionSiteService()
